module.exports = __webpack_public_path__ + "img/lowres-ft-provider.7db56790.png";